import * as React from "react";
import { useParams } from "react-router";

export function useRequiredParams<K extends string>(keys: readonly K[]) {
  const params = useParams();

  React.useEffect(() => {
    const missingParams = keys.filter((key) => !params[key]);
    if (missingParams.length > 0) {
      throw new Error(
        `Required parameters are missing: ${missingParams.join(", ")}`,
      );
    }
  }, [params, keys]);

  return params as Record<K, string>;
}
